import { isDefined } from '#misc/is-defined.guard';

/**
 * Determines if the DOM can be used in the current environment.
 *
 * This utility checks whether the `window` object is defined and if the `document.createElement`
 * method is available, indicating that DOM operations are possible (e.g., in a browser context).
 *
 * @remarks
 * Useful for distinguishing between browser and server-side (e.g., Node.js) environments.
 *
 * @example
 * if (canUseDom) {
 *   // Safe to use DOM APIs
 * }
 */
export const canUseDom = isDefined(globalThis.window) && 'createElement' in globalThis.window.document;
